import styled from 'styled-components';
import { atomicBlockContainerWidth, colorUsage, getSpacing, zIndex } from 'stylesheet';
import { Edit, Trash } from 'theme/icons';
var Container = styled.div.withConfig({
  displayName: "ImageBlockstyle__Container",
  componentId: "sc-1bcqutl-0"
})(["display:flex;justify-content:center;width:", ";margin:auto;"], atomicBlockContainerWidth);
var Img = styled.img.withConfig({
  displayName: "ImageBlockstyle__Img",
  componentId: "sc-1bcqutl-1"
})(["max-width:100%;height:auto;opacity:1;"]);
var EditIcon = styled(Edit).withConfig({
  displayName: "ImageBlockstyle__EditIcon",
  componentId: "sc-1bcqutl-2"
})(["path{fill:", ";}"], colorUsage.paletteOverride.primary.main);
var TrashIcon = styled(Trash).withConfig({
  displayName: "ImageBlockstyle__TrashIcon",
  componentId: "sc-1bcqutl-3"
})(["path{fill:", ";}"], colorUsage.paletteOverride.primary.main);
var ImageHover = styled.div.withConfig({
  displayName: "ImageBlockstyle__ImageHover",
  componentId: "sc-1bcqutl-4"
})(["position:absolute;z-index:", ";display:none;align-items:center;justify-content:center;width:100%;height:100%;"], zIndex.buttonHover);
var HoverButtonContainer = styled.div.withConfig({
  displayName: "ImageBlockstyle__HoverButtonContainer",
  componentId: "sc-1bcqutl-5"
})(["display:flex;gap:", ";"], getSpacing(3));
var ViewContainer = styled.aside.withConfig({
  displayName: "ImageBlockstyle__ViewContainer",
  componentId: "sc-1bcqutl-6"
})(["position:relative;&:hover{", "{display:flex;}", "{opacity:0.6;}}"], ImageHover, Img);
export { Container, Img, EditIcon, TrashIcon, ImageHover, HoverButtonContainer, ViewContainer };